import styled from "styled-components";

export const MenuStyle = styled.div`
  div .show {
    border: 1px ridge white;
    padding: 1rem;
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    transition: 0.2s;
  }
`;
